const PANELS = '[data-drawer-panel]';
const NOTICES = '[data-report-obstacle]';
const ROOTS = `${PANELS}, ${NOTICES}`;

// Keep the fixed report button above controls in the foremost drawer at its right edge.
export function observeReportButtonPosition(button) {
    let frame = null;
    let stopped = false;
    let observed = new Set();
    const schedule = () => {
        if (!stopped && frame === null) frame = window.requestAnimationFrame(update);
    };
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

    function update() {
        frame = null;
        if (stopped) return;
        const buttonRect = button.getBoundingClientRect();
        const height = window.innerHeight;
        const visibleRect = element => {
            const rect = element.getBoundingClientRect();
            const style = window.getComputedStyle(element);
            return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < height
                && rect.left < buttonRect.right && rect.right > buttonRect.left
                && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0' ? rect : null;
        };
        const panels = [...document.querySelectorAll(PANELS)];
        const activePanel = panels.filter(visibleRect).reverse().sort((a, b) =>
            (parseInt(window.getComputedStyle(b).zIndex, 10) || 0)
            - (parseInt(window.getComputedStyle(a).zIndex, 10) || 0)
        )[0];
        const obstacles = [...(activePanel
            ? activePanel.querySelectorAll('.fixed-bottom') : document.querySelectorAll(NOTICES))];
        const panelRect = activePanel?.getBoundingClientRect();
        let bottom = 0;
        obstacles.forEach(element => {
            const rect = visibleRect(element);
            if (!rect || (panelRect && (rect.bottom <= panelRect.top || rect.top >= panelRect.bottom))) return;
            if (activePanel && window.getComputedStyle(element).position !== 'fixed') return;
            bottom = Math.max(bottom, height - Math.max(rect.top, panelRect?.top || 0) + 4);
        });
        const offset = `${Math.ceil(Math.min(bottom, Math.max(0, height - buttonRect.height - 4)))}px`;
        if (button.style.getPropertyValue('--report-bottom-offset') !== offset) {
            button.style.setProperty('--report-bottom-offset', offset);
        }
        const nextObserved = new Set([button, ...panels, ...obstacles]);
        observed.forEach(element => { if (!nextObserved.has(element)) resizeObserver?.unobserve(element); });
        nextObserved.forEach(element => { if (!observed.has(element)) resizeObserver?.observe(element); });
        observed = nextObserved;
    }

    const containsRoot = node => node.nodeType === 1 && (node.matches(ROOTS) || node.querySelector(ROOTS));
    const mutationObserver = new MutationObserver(records => {
        if (records.some(record => record.target.closest?.(ROOTS)
            || (record.type === 'attributes' && containsRoot(record.target))
            || [...record.addedNodes, ...record.removedNodes].some(containsRoot))) schedule();
    });
    mutationObserver.observe(document.body, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'],
    });
    const transitionEnded = event => { if (event.target.closest?.(ROOTS)) schedule(); };
    document.addEventListener('transitionend', transitionEnded);
    window.addEventListener('resize', schedule);
    update();

    return () => {
        stopped = true;
        if (frame !== null) window.cancelAnimationFrame(frame);
        mutationObserver.disconnect();
        resizeObserver?.disconnect();
        document.removeEventListener('transitionend', transitionEnded);
        window.removeEventListener('resize', schedule);
    };
}
